import Button from '../../atoms/button';
import styles from './StoreListItem.module.scss';
import { Channel, SpecialHour, StoreListItemProps } from './types';
import clsx from 'clsx';
import React, { FC } from 'react';
import { getSpecialHoursArray } from '../../../hooks/useStoreLocator';

const StoreListItem: FC<StoreListItemProps> = ({
  store,
  setShowDrawer,
  skuId,
  setSelectedStore,
  selectedStore,
  shouldHideClickCollect,
}) => {
  const availability = store.availability && store.quantity > 0;

  const handleSetSelectedStore = (data: { channel: Channel; skuId: string }): void => {
    setSelectedStore(data);
    setShowDrawer(false);
  };

  const specialHours: SpecialHour[] = getSpecialHoursArray(store);

  return (
    <div className={styles.storeListItem}>
      <div>
        <h4 className={styles.storeListTitle}>{store.storeName}</h4>
        <div className={clsx(styles.stock, availability && styles.inStock)}>
          {availability ? (
            store.collect ? (
              <p>{shouldHideClickCollect ? 'Item is available' : 'Item is available for pickup'}</p>
            ) : (
              <p>{shouldHideClickCollect ? 'Item is available' : 'Item can be purchased in store'}</p>
            )
          ) : (
            <p>
              Item is <span>not</span> in stock
            </p>
          )}
        </div>
        <div className={styles.storeListText}>
          <p>
            <span>Address:</span> {store.address}
          </p>
          {store.todayHour && (
            <p>
              <span>Today's hours:</span> {store.todayHour.time}
            </p>
          )}
          {store.telephone && (
            <p>
              <span>Phone:</span> {store.telephone}
            </p>
          )}
          {store?.['department-list'] && (
            <p>
              <span className={styles.boldText}>Department:</span> {store?.['department-list']?.join(', ')}
            </p>
          )}
          {specialHours?.length > 0 && (
            <p>
              <span className={styles.boldText}>Special hours:</span>
              {specialHours.map((item, index) => (
                <span key={index} className={styles.specialHours}>
                  <span>{item.name}:&nbsp;</span>
                  <span>{item.value}</span>
                </span>
              ))}
            </p>
          )}
        </div>
      </div>
      {!shouldHideClickCollect && availability && store.collect && (
        <div className={styles.storeListItemBtn}>
          {/*@ts-ignore*/}
          <Button
            variant={selectedStore?.channel?.id === store?.id ? 'primary' : 'secondary'}
            as="button"
            data-new-store-item-action="store_item_action"
            className={clsx({ [styles.disabledBtn]: selectedStore?.channel?.id === store.id })}
            onClick={() =>
              handleSetSelectedStore({
                channel: {
                  id: store.id,
                  key: store.key,
                },
                skuId,
              })
            }
          >
            Collect in store
          </Button>
        </div>
      )}
    </div>
  );
};

export default StoreListItem;
